import { AutocompleteType ,TextFieldType} from "../../../../utilis/component/CustomFormElement"


type medicalHistoryFormType={
    Diseases:AutocompleteType,
    Duration:TextFieldType,
    Medication:TextFieldType
}

export const medicalHistoryForm:medicalHistoryFormType={

    Diseases:{
            element:"autocomplete",
            name:"diseaseDetails",
            fieldProps:{label:"Diseases"},
            rules:{required:"Diseases Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.icdName,
                isOptionEqualToValue: (option, value) => option.icdId == value.icdId,
              }
    },
    Duration:{
        element: "input",
        name: "duration",
        fieldProps: {label: "Duration",type:'text'},
        rules: {required: "Duration required"}

    },
    Medication:{
        element: "input",
        name: "medication",
        fieldProps: {label: "Medication",type:'text'},
        rules:{required:false}
    }

}



